/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor",
]);

export { acceleratedValues };
//# sourceMappingURL=accelerated-values.mjs.map
